import {
    fork, take, all
} from 'redux-saga/effects';

import { appService } from './app/app-service';
import { operationsService } from './operations/operations-service';
import { omjsService } from './omjs/omjs-service';
import { objectWindowService } from './object-window/object-window-service';
import { mapService } from './map/map-service';
import { containersService } from './containers/containers-service';
import { listWindowService } from './list-window/list-window-service';
import { favoritesService } from './favorites/favorites-service';
import { objectsComparisonService } from './objects-comparison/objects-comparison-service';
import { overlayWindowsService } from './overlay-windows/overlay-windows-service';
import { searchService } from './search/search-service';

export const serviceRunner = function* serviseRunner() {
    while (true) {
        const { 'payload': service } = yield take('RUN_SERVICE');
        service.rootTask = yield fork(function* () {
            yield all(service.constructor.generatedWatchers.map(w => w()));
        });
    }
};

export {
    appService,
    operationsService,
    omjsService,
    objectWindowService,
    mapService,
    containersService,
    listWindowService,
    favoritesService,
    overlayWindowsService,
    searchService
};

export const initServices = [
    omjsService,
    appService,
    operationsService,
    objectWindowService,
    mapService,
    containersService,
    listWindowService,
    favoritesService,
    objectsComparisonService,
    overlayWindowsService,
    searchService
];
